import { isServerEnvironment } from '@cash-web/shared-util-environment'
import { assetUrl } from '@cash-web/shared-util-url'

const isSsr = isServerEnvironment()

export const prefetchCardAssets = async () => {
  let tortoiseAssetUrl: string

  // This is part of the journey lib which all apps consume, so we need to handle the SSR case.
  // Only prefetch the tortoise image where window.cdn.version is available.
  if (!isSsr) {
    tortoiseAssetUrl = assetUrl({
      pathPrefix: 'cards',
      filename: 'tortoise.png',
      developmentPathPrefix: '/assets/cards/tortoise.png',
      namespace: 'account',
    })
  }

  const tortoiseImg = !isSsr
    ? new Promise(resolve => {
        const img = new Image()
        img.src = tortoiseAssetUrl
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
      })
    : Promise.resolve(true)

  const cardComponents = Promise.allSettled([
    import(/* webpackChunkName: "BlackCard-SVGComponent" */ './card-assets/Black'),
    import(/* webpackChunkName: "WhiteCard-SVGComponent" */ './card-assets/White'),
    import(/* webpackChunkName: "PinkCard-SVGComponent" */ './card-assets/Pink'),
    import(/* webpackChunkName: "GlowInTheDarkCard-SVGComponent" */ './card-assets/GlowInTheDark'),
    import(/* webpackChunkName: "ChameleonMetalCard-SVGComponent" */ './card-assets/ChameleonMetal'),
    import(/* webpackChunkName: "ChipCard-SVGComponent" */ './card-assets/Chip'),
    import(/* webpackChunkName: "BlackMetalCard-SVGComponent" */ './card-assets/BlackMetal'),
    import(/* webpackChunkName: "DreamCard-SVGComponent" */ './card-assets/Dream'),
    import(/* webpackChunkName: "GlitterCard-SVGComponent" */ './card-assets/Glitter'),
    import(/* webpackChunkName: "MoodCard-SVGComponent" */ './card-assets/Mood'),
    import(/* webpackChunkName: "TortoiseCard-SVGComponent" */ './card-assets/Tortoise'),
    import(/* webpackChunkName: "ShantellMartinCard-SVGComponent" */ './card-assets/ShantellMartin'),
    import(/* webpackChunkName: "HundredThievesCard-SVGComponent" */ './card-assets/HundredThieves'),
    import(/* webpackChunkName: "HoloCard-SVGComponent" */ './card-assets/Holo'),
  ])

  await Promise.allSettled([tortoiseImg, cardComponents])
}
